import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from '../../../actions/ActionTypes';
import Article from '../../../records/ArticleRecord';
const getArticlesFromCategoriesOrganization = payload => {
  const allArticles = {};
  for (const category of payload.categories) {
    for (const article of category.articles || []) {
      const articleRecord = new Article(article);
      allArticles[articleRecord.values.hs_id] = articleRecord;
    }
    for (const subcategory of category.subcategories || []) {
      for (const article of subcategory.articles || []) {
        const articleRecord = new Article(article);
        allArticles[articleRecord.values.hs_id] = articleRecord;
      }
    }
  }
  return ImmutableMap(allArticles);
};
const copyParentKnowledgeCategoryId = (state, targetArticleId, newSiblingArticleId) => state.setIn([`${targetArticleId}`, 'values', 'hs_knowledge_category_id'], state.getIn([`${newSiblingArticleId}`, 'values', 'hs_knowledge_category_id']));
const setKnowledgeCategoryId = (state, articleId, knowledgeCategoryId) => state.setIn([`${articleId}`, 'values', 'hs_knowledge_category_id'], knowledgeCategoryId);
const INITIAL_STATE = ImmutableMap();
export default function articles(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.CLEAR_ORGANIZE_STATE:
      return INITIAL_STATE;
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
    case ActionTypes.FETCH_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_SUCCESS:
      return getArticlesFromCategoriesOrganization(action.payload);
    case ActionTypes.DROP_ARTICLE_ON_SUBCATEGORY:
      return setKnowledgeCategoryId(state, action.payload.dragArticleId, action.payload.dropSubcategoryId);
    case ActionTypes.DROP_ARTICLE_ON_CATEGORY:
      return setKnowledgeCategoryId(state, action.payload.dragArticleId, action.payload.dropCategoryId);
    case ActionTypes.DROP_ARTICLE_ON_ARTICLE:
      return copyParentKnowledgeCategoryId(state, action.payload.dragArticleId, action.payload.dropArticleId);
    case ActionTypes.UPDATE_ARTICLE_ORDERING_ERROR:
      {
        return setKnowledgeCategoryId(state, action.payload.revertInfo.articleId, action.payload.revertInfo.originalParentId);
      }
    default:
      return state;
  }
}